import { useLocation } from "react-router-dom";

// Deep-link payload passed via location.state when opening a training from another screen.
export type TrainingsRouteIntent = {
  trainingTemplateId?: number;
  trainingStatus?: number;
  targetTrainingId?: number;
  targetCustomerId?: number;
  searchQuery?: string;
  alertKey?: string;
  alertName?: string;
  select?: string;
};

export function useTrainingsRouteIntent(): TrainingsRouteIntent {
  const location = useLocation();

  return (location.state as TrainingsRouteIntent | null) ?? {};
}
